import React, { useEffect } from 'react';
import mova from 'mova';
import PropTypes from 'prop-types';
import './Payment.scss';
import Loading from '@components/feedback/Loading/Loading';
import Entity404 from '../Error/Entity404';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getBillingByHash } from '@actions/billing';
import PaymentSuccess from './PaymentSuccess';

const t = mova.ns('pages.Payment');

function SuccessfulPayment({ match, getBillingByHash, loading, billing }) {
  const { billingHash } = match.params;

  useEffect(() => {
    getBillingByHash(billingHash);
  }, [billingHash, getBillingByHash]);

  if (loading) {
    return <Loading />;
  } else if (!billing) {
    return <Entity404 entity={t('reservation')} />;
  }

  return (
    <div className='payment'>
      <div className='payment__reservation-info reservation-info'>
        <PaymentSuccess billing={billing} />
      </div>
    </div>
  );
}

SuccessfulPayment.propTypes = {
  match: PropTypes.object.isRequired,
  billing: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  getBillingByHash: PropTypes.func.isRequired,
};

SuccessfulPayment.defaultProps = {
  billing: undefined,
};

const mapStateToProps = ({ billing }) => ({
  billing: billing.data,
  loading: billing.isLoading,
});

const mapDispatchToProps = {
  getBillingByHash,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SuccessfulPayment));
